import React from "react";
import "./Form.css";

const Form = () => {
  return (
    <>
      <div className="form-content" id="contactus">
        <div className="form-header">
          <h1>LET’S MAKE SOMETHING TOGETHER</h1>
          <p>
            We have a unique story with each client. So tell your story here, how can we help you?
          </p>
        </div>
      </div>
    </>
  );
};

export default Form;
